/* =============================================================================
   La Castagne — comportements du thème Shopify.
   Aucune dépendance. Le panier localStorage de la maquette est remplacé par
   les routes natives /cart/add.js et /cart.js.
   ========================================================================== */
(() => {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* --- Toast ------------------------------------------------------------ */
  const boiteToast = $('[data-toast]');
  let minuteurToast;
  function toast(message) {
    if (!boiteToast) return;
    boiteToast.textContent = message;
    boiteToast.dataset.visible = '1';
    clearTimeout(minuteurToast);
    minuteurToast = setTimeout(() => (boiteToast.dataset.visible = '0'), 3600);
  }

  /* --- Compteur du panier ----------------------------------------------- */
  function majCompteur(n) {
    $$('[data-panier-compte]').forEach((el) => {
      el.textContent = n > 0 ? String(n) : '';
      el.dataset.vide = n > 0 ? '0' : '1';
    });
  }

  /* --- En-tête rétractable ---------------------------------------------
     On l'efface en descendant, on le ramène au moindre mouvement vers le
     haut. C'est ce qui évite de remonter toute la page pour atteindre le
     panier après un ajout depuis la barre du bas. */
  const entete = $('.entete');
  // C'est le conteneur de section posé par Shopify qui est collant, donc c'est
  // lui qu'on efface, pas l'en-tête lui-même.
  const enteteBloc = entete?.closest('.shopify-section') || entete;

  if (entete && enteteBloc) {
    let dernier = window.scrollY;
    let enAttente = false;

    const suivreDefilement = () => {
      const y = Math.max(0, window.scrollY);
      const hauteur = entete.offsetHeight;

      // Menu mobile ouvert : l'en-tête porte son bouton de fermeture, il doit
      // rester en place quoi qu'il arrive au défilement derrière.
      if (document.querySelector('#menu-mobile')?.dataset.ouvert === '1') {
        enteteBloc.dataset.cache = '0';
        dernier = y;
        enAttente = false;
        return;
      }

      // Sous la hauteur de l'en-tête, il reste toujours visible : le masquer
      // là ferait clignoter la barre au premier pixel de défilement.
      if (y <= hauteur) enteteBloc.dataset.cache = '0';
      else if (y > dernier + 4) enteteBloc.dataset.cache = '1';
      else if (y < dernier - 4) enteteBloc.dataset.cache = '0';

      dernier = y;
      enAttente = false;
    };

    window.addEventListener('scroll', () => {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(suivreDefilement);
    }, { passive: true });
  }

  /* --- Menu mobile ------------------------------------------------------ */
  const menu = $('#menu-mobile');
  const ouvreMenu = $('[data-ouvre-menu]');

  function basculeMenu(ouvert) {
    if (!menu || !ouvreMenu) return;
    menu.dataset.ouvert = ouvert ? '1' : '0';
    menu.setAttribute('aria-hidden', ouvert ? 'false' : 'true');
    ouvreMenu.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    document.body.style.overflow = ouvert ? 'hidden' : '';
    if (ouvert) $('a', menu)?.focus();
    else ouvreMenu.focus();
  }

  ouvreMenu?.addEventListener('click', () => basculeMenu(true));
  $('[data-ferme-menu]')?.addEventListener('click', () => basculeMenu(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu?.dataset.ouvert === '1') basculeMenu(false);
  });

  /* --- Tiroir panier ----------------------------------------------------
     Le contenu du tiroir est rendu par Shopify et rechargé via l'API de rendu
     de section après chaque changement : les montants gardent le format
     monétaire de la boutique, sans le réimplémenter en JavaScript.

     L'enveloppe <dialog> vit dans la mise en page, hors de la section : le
     rechargement du contenu ne détruit donc pas le dialogue ouvert. Toutes les
     commandes passent par délégation, ce qui évite de réattacher des
     écouteurs à chaque rafraîchissement. */
  const tiroir = $('dialog.tiroir');
  const blocTiroir = $('#shopify-section-panier-tiroir');
  let positionAvantTiroir = 0;

  /** Rend au visiteur le défilement et la position qu'il avait. */
  function rendreLaPage() {
    document.body.style.overflow = '';
    if (Math.abs(window.scrollY - positionAvantTiroir) > 2) {
      window.scrollTo({ top: positionAvantTiroir, behavior: 'instant' });
    }
  }

  function ouvrirTiroir(ouvert) {
    if (!tiroir) return;

    if (ouvert) {
      if (!tiroir.open) {
        positionAvantTiroir = window.scrollY;
        // showModal place le dialogue dans le calque supérieur : il échappe au
        // flux, aux transformations d'ancêtre et aux empilements de la page.
        // Le navigateur gère aussi le piège à focus et la touche Échap.
        tiroir.showModal();
      }
      document.body.style.overflow = 'hidden';
    } else {
      if (tiroir.open) tiroir.close();
      rendreLaPage();
    }
  }

  // L'entrée du panneau est une animation CSS déclenchée par l'attribut open.
  // Piloter une transition depuis le script demandait un requestAnimationFrame
  // et un minuteur de sortie, qui ne se déclenchent pas de façon fiable quand
  // l'onglet n'est pas au premier plan : le panneau restait alors hors écran.

  // Échap ferme nativement le dialogue : on repasse par la remise en état.
  tiroir?.addEventListener('close', rendreLaPage);

  // Clic sur le fond : la cible est le dialogue lui-même, le panneau ne
  // couvrant qu'une partie de sa surface.
  tiroir?.addEventListener('click', (e) => {
    if (e.target === tiroir) ouvrirTiroir(false);
  });

  /** Recharge le contenu du tiroir et le compteur de l'en-tête. */
  async function rafraichirTiroir() {
    if (!blocTiroir) return;
    try {
      const r = await fetch(`${location.pathname}?sections=panier-tiroir`);
      const sections = await r.json();
      const recu = new DOMParser().parseFromString(sections['panier-tiroir'], 'text/html');
      const neuf = recu.querySelector('#shopify-section-panier-tiroir');
      if (neuf) blocTiroir.innerHTML = neuf.innerHTML;
    } catch {
      // Le tiroir garde alors son contenu précédent : /cart reste accessible.
      toast('Le panier n’a pas pu être rafraîchi.');
    }
    const panier = await (await fetch('/cart.js')).json();
    majCompteur(panier.item_count);
  }

  if (blocTiroir) {
    // L'icône panier de l'en-tête reste un lien vers /cart : on ne fait que
    // l'intercepter, elle continue de fonctionner sans JavaScript.
    $$(`a[href$="${'/cart'}"], a[href*="/cart?"]`).forEach((lien) => {
      lien.addEventListener('click', async (e) => {
        e.preventDefault();
        // On ouvre d'abord, pour que le geste réponde tout de suite, puis on
        // remet le contenu à jour : le panier a pu changer dans un autre
        // onglet, ou expirer depuis le rendu de la page.
        ouvrirTiroir(true);
        await rafraichirTiroir();
      });
    });

    blocTiroir.addEventListener('click', async (e) => {
      if (e.target.closest('[data-tiroir-fermer]')) { ouvrirTiroir(false); return; }

      const retirer = e.target.closest('[data-retirer-ligne]');
      if (retirer) {
        await changerLigne(retirer.dataset.retirerLigne, 0);
        return;
      }

      const pas = e.target.closest('[data-pas]');
      if (pas) {
        const champ = $('.quantite__champ', pas.closest('[data-quantite]'));
        const n = Math.min(99, Math.max(0, (Number(champ.value) || 0) + Number(pas.dataset.pas)));
        champ.value = String(n);
        await changerLigne(champ.dataset.ligne, n);
      }
    });

    blocTiroir.addEventListener('change', async (e) => {
      const champ = e.target.closest('.quantite__champ');
      if (!champ) return;
      const n = Math.min(99, Math.max(0, Number(champ.value) || 0));
      champ.value = String(n);
      await changerLigne(champ.dataset.ligne, n);
    });

    // Pas d'écouteur pour Échap : un dialogue ouvert en modal le gère
    // nativement, et son événement close repasse par notre remise en état.
  }

  /** Met à jour une ligne du panier puis recharge le tiroir. */
  async function changerLigne(ligne, quantite) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(ligne), quantity: quantite }),
    });
    if (!r.ok) { toast('La mise à jour du panier a échoué.'); return; }
    // La page panier affiche les mêmes lignes que le tiroir : la recharger est
    // le seul moyen de la garder juste. Ailleurs, seul le tiroir bouge.
    if ($('[data-page-panier]') || !blocTiroir) location.reload();
    else await rafraichirTiroir();
  }

  /* --- Fiche produit ---------------------------------------------------- */
  const formeProduit = $('[data-produit]');

  if (formeProduit && $('#donnees-produit')) {
    const donnees   = JSON.parse($('#donnees-produit').textContent);
    const champId   = $('[data-variante-id]', formeProduit);
    const nomCuir   = $('[data-cuir-nom]', formeProduit);
    const descCuir  = $('[data-cuir-desc]', formeProduit);
    const principale = $('[data-galerie-principale]');
    const vignettes  = $('[data-galerie-vignettes]');

    // Le prix et le bouton existent en plusieurs exemplaires : dans le
    // formulaire et dans la barre collante. Tout se met à jour ensemble.
    const prix     = () => $$('[data-prix]');
    const boutons  = () => $$('[data-ajouter]');
    const libelles = () => $$('[data-ajouter-libelle]');

    const choix = () => $$('input[type="radio"][data-position]', formeProduit)
      .filter((r) => r.checked)
      .sort((a, b) => a.dataset.position - b.dataset.position)
      .map((r) => r.value);

    function varianteCourante() {
      const voulu = choix();
      return donnees.variantes.find((v) =>
        v.options.length === voulu.length && v.options.every((o, i) => o === voulu[i]));
    }

    /* --- Liste déroulante des cuirs ------------------------------------- */
    const listeCuir = $('[data-liste-cuir]');
    let majDeclencheurCuir = null;

    if (listeCuir) {
      const declencheur = $('[data-cuir-declencheur]', listeCuir);
      const panneau     = $('[data-cuir-panneau]', listeCuir);
      const apercu      = $('[data-cuir-apercu]', listeCuir);
      const valeur      = $('[data-cuir-valeur]', listeCuir);
      const prixCuir    = $('[data-cuir-prix]', listeCuir);

      // Le panneau n'est replié qu'ici : sans script il reste ouvert et le
      // choix se fait sur les boutons radio comme sur n'importe quel formulaire.
      panneau.hidden = true;

      const ouvrir = (etat) => {
        panneau.hidden = !etat;
        declencheur.setAttribute('aria-expanded', String(etat));
        // Les puces radio sont transparentes et étirées sur toute la ligne :
        // les focaliser sans preventScroll fait sauter la page vers elles.
        if (etat) $('input:checked', panneau)?.focus({ preventScroll: true });
      };

      declencheur.addEventListener('click', () =>
        ouvrir(declencheur.getAttribute('aria-expanded') !== 'true'));

      // Un choix referme la liste et rend la main au déclencheur.
      panneau.addEventListener('change', () => {
        ouvrir(false);
        declencheur.focus();
      });

      document.addEventListener('click', (e) => {
        if (!listeCuir.contains(e.target)) ouvrir(false);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panneau.hidden) { ouvrir(false); declencheur.focus(); }
      });

      /** Recopie sur le déclencheur la pastille, le nom et le prix du cuir choisi. */
      majDeclencheurCuir = (radio, prixFormate) => {
        const ligne = radio.closest('.option');
        const pastilles = ligne?.querySelector('.pastilles-cuir');
        if (apercu && pastilles) apercu.innerHTML = pastilles.outerHTML;
        if (valeur) valeur.textContent = radio.value;
        if (prixCuir) prixCuir.textContent = prixFormate;
      };
    }

    /** Bascule la grande image, en réutilisant la vignette correspondante. */
    function afficherMedia(mediaId) {
      const cible = vignettes && $(`[data-media-id="${mediaId}"]`, vignettes);
      if (!cible || !principale) return;
      const img = principale.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = cible.dataset.grande;
        img.alt = cible.dataset.alt || '';
      }
      $$('button', vignettes).forEach((b) =>
        b.setAttribute('aria-pressed', String(b === cible)));
    }

    /* --- Galerie filtrée par coloris -------------------------------------
       On ne montre que les photos du cuir choisi, plus celles qui ne sont
       rattachées à aucun coloris. Si le cuir n'a encore aucune photo, cas des
       coudières dont le shooting manque, on retombe sur la galerie entière
       plutôt que d'afficher un cadre vide. */
    const compte = $('[data-galerie-compte]');

    function filtrerGalerie(cuir) {
      if (!vignettes) return;
      const toutes = $$('button', vignettes);
      const duCuir = toutes.filter((b) => (b.dataset.cuirs || '').split('|').includes(cuir));
      const sansColoris = toutes.filter((b) => !(b.dataset.cuirs || '').trim());
      const visibles = duCuir.length ? [...duCuir, ...sansColoris] : toutes;

      toutes.forEach((b) => { b.hidden = !visibles.includes(b); });
      vignettes.scrollLeft = 0;

      if (compte) {
        // On ne met pas le coloris en minuscules : « en drapeau algérie » se
        // lit mal, et « Bicolore or » perdrait sa majuscule de référence.
        const n = `${visibles.length} photo${visibles.length > 1 ? 's' : ''}`;
        compte.textContent = duCuir.length ? `${n} · ${cuir}` : n;
      }
      majFleches();
      return visibles;
    }

    /* --- Défilement du rail de vignettes --------------------------------- */
    const fleches = $$('[data-defiler]');

    function majFleches() {
      if (!vignettes) return;
      const debord = vignettes.scrollWidth - vignettes.clientWidth > 4;
      fleches.forEach((f) => { f.hidden = !debord; });
      if (!debord) return;
      const avant = fleches.find((f) => f.dataset.defiler === '-1');
      const apres = fleches.find((f) => f.dataset.defiler === '1');
      if (avant) avant.disabled = vignettes.scrollLeft <= 2;
      if (apres) {
        apres.disabled =
          vignettes.scrollLeft >= vignettes.scrollWidth - vignettes.clientWidth - 2;
      }
    }

    fleches.forEach((f) => {
      f.addEventListener('click', () => {
        // On fait défiler d'un peu moins d'une largeur visible, pour garder
        // une vignette de repère entre deux écrans.
        vignettes.scrollBy({ left: Number(f.dataset.defiler) * vignettes.clientWidth * 0.8 });
      });
    });
    vignettes?.addEventListener('scroll', majFleches, { passive: true });
    window.addEventListener('resize', majFleches);

    const choixBarre = $('[data-barre-choix]');
    const imageBarre = $('[data-barre-image]');

    function majVariante() {
      const v = varianteCourante();
      const cuir = $$('input[data-position="1"]', formeProduit).find((r) => r.checked);

      let visibles = null;
      if (cuir) {
        if (nomCuir) nomCuir.textContent = cuir.value;
        if (descCuir && cuir.dataset.desc) descCuir.textContent = cuir.dataset.desc.trim();
        if (typeof majDeclencheurCuir === 'function') {
          majDeclencheurCuir(cuir, v ? v.prixFormate : '');
        }
        visibles = filtrerGalerie(cuir.value);
      }

      if (!v) {
        boutons().forEach((b) => { b.disabled = true; });
        libelles().forEach((l) => { l.textContent = 'Combinaison indisponible'; });
        return;
      }

      champId.value = v.id;
      prix().forEach((p) => { p.textContent = v.prixFormate; });
      boutons().forEach((b) => { b.disabled = !v.disponible; });
      libelles().forEach((l) => {
        l.textContent = v.disponible ? 'Ajouter au panier' : 'Indisponible';
      });
      if (choixBarre) choixBarre.textContent = v.options.join(' · ');

      // La photo de la variante est en principe dans le lot filtré. Si le
      // filtrage vient de la masquer, on montre la première photo visible
      // plutôt que de laisser la grande image sur un autre coloris.
      const photoVariante = v.mediaId && vignettes
        && $(`[data-media-id="${v.mediaId}"]`, vignettes);
      if (photoVariante && !photoVariante.hidden) afficherMedia(v.mediaId);
      else if (visibles && visibles[0]) afficherMedia(visibles[0].dataset.mediaId);

      // Reflète le choix dans l'URL, sans polluer l'historique.
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u);
    }

    $$('input[type="radio"][data-position]', formeProduit).forEach((r) =>
      r.addEventListener('change', majVariante));

    // Clic manuel sur une vignette : on regarde simplement la photo.
    $$('button', vignettes || document.createElement('div')).forEach((b) => {
      b.addEventListener('click', () => afficherMedia(b.dataset.mediaId));
    });

    majVariante();

    /* --- Barre d'achat collante -----------------------------------------
       Elle se montre dès que le bouton du formulaire quitte l'écran par le
       haut. On surveille le bouton lui-même plutôt que la position de
       défilement : la hauteur de la fiche change avec le nombre de photos. */
    const barre = $('[data-barre-achat]');
    const boutonPrincipal = $('[data-ajouter]', formeProduit);

    if (barre && boutonPrincipal && 'IntersectionObserver' in window) {
      barre.hidden = false;
      const observateur = new IntersectionObserver(([entree]) => {
        // Visible seulement quand le bouton est sorti par le haut. Tant qu'on
        // est au-dessus de lui, la barre resterait un doublon inutile.
        const sortiParLeHaut = !entree.isIntersecting
          && entree.boundingClientRect.top < 0;
        barre.dataset.visible = sortiParLeHaut ? '1' : '0';
      }, { threshold: 0 });
      observateur.observe(boutonPrincipal);
    }

    // La galerie change de photo : la vignette de la barre suit.
    if (imageBarre) {
      const suivre = () => {
        const grande = principale?.querySelector('img');
        if (grande?.src) imageBarre.src = grande.src;
      };
      formeProduit.addEventListener('change', () => setTimeout(suivre, 0));
    }

    formeProduit.addEventListener('submit', async (e) => {
      e.preventDefault();
      const v = varianteCourante();
      if (!v) return;

      boutons().forEach((b) => { b.disabled = true; });
      libelles().forEach((l) => { l.textContent = 'Ajout en cours…'; });
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
        });
        if (!r.ok) throw new Error((await r.json()).description || 'Ajout impossible');
        // Le tiroir sert de confirmation : il montre ce qui vient d'être
        // ajouté et donne accès au paiement, sans quitter la fiche.
        if (blocTiroir) {
          await rafraichirTiroir();
          ouvrirTiroir(true);
        } else {
          majCompteur((await (await fetch('/cart.js')).json()).item_count);
          toast(`${v.options.join(', ')} ajouté au panier.`);
        }
      } catch (err) {
        toast(err.message);
      } finally {
        boutons().forEach((b) => { b.disabled = false; });
        libelles().forEach((l) => { l.textContent = 'Ajouter au panier'; });
      }
    });
  }

  /* --- Page panier ------------------------------------------------------
     Elle reste accessible en direct et sans JavaScript. Ses compteurs passent
     par le même changerLigne que le tiroir, qui sait recharger la page quand
     c'est elle qu'on regarde. */

  $$('[data-quantite]').forEach((groupe) => {
    const champ = $('.quantite__champ', groupe);
    if (!champ) return;

    const borner = (n) => Math.min(99, Math.max(0, n));

    const majBoutons = () => {
      const n = Number(champ.value) || 0;
      $$('[data-pas]', groupe).forEach((b) => {
        b.disabled = (b.dataset.pas === '-1' && n <= 0) || (b.dataset.pas === '1' && n >= 99);
      });
    };
    majBoutons();

    $$('[data-pas]', groupe).forEach((bouton) => {
      bouton.addEventListener('click', () => {
        const n = borner((Number(champ.value) || 0) + Number(bouton.dataset.pas));
        champ.value = String(n);
        majBoutons();
        changerLigne(champ.dataset.ligne, n);
      });
    });

    // Saisie au clavier : on n'envoie qu'à la sortie du champ, pour ne pas
    // recharger la page à chaque frappe.
    champ.addEventListener('change', () => {
      const n = borner(Number(champ.value) || 0);
      champ.value = String(n);
      changerLigne(champ.dataset.ligne, n);
    });
  });

  $$('[data-retirer-ligne]').forEach((lien) => {
    lien.addEventListener('click', (e) => {
      e.preventDefault();
      changerLigne(lien.dataset.retirerLigne, 0);
    });
  });

  /* --- Retour de formulaire --------------------------------------------- */
  const retourEnvoi = $('#retour-envoi');
  if (retourEnvoi) {
    retourEnvoi.scrollIntoView({ behavior: 'smooth', block: 'center' });
    retourEnvoi.focus({ preventScroll: true });
  }
})();
